import { render, staticRenderFns } from "./CheckupsOverview.vue?vue&type=template&id=b6249a94"
import script from "./CheckupsOverview.vue?vue&type=script&lang=ts"
export * from "./CheckupsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports